var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuoteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 38.954,
    height: 30.134,
    viewBox: "0 0 38.954 30.134",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17871",
    "data-name": "Rectangle 17871",
    width: 38.954,
    height: 30.134,
    transform: "translate(0 0)",
    fill: "#3db6fb"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_47006",
    "data-name": "Group 47006",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_47005",
    "data-name": "Group 47005",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_46664",
    "data-name": "Path 46664",
    d: "M16.589,4.62C13.229,6.4,9.344,10.814,8.4,14.6a5.155,5.155,0,0,1,2.1-.316c3.99,0,7.14,3.045,7.14,7.56a8.382,8.382,0,0,1-8.3,8.3C4.41,30.134,0,26.249,0,19.424,0,11.55,4.3,4.515,10.814,0Zm21.42,0c-3.36,1.784-7.351,6.194-8.19,9.975a5.158,5.158,0,0,1,2.1-.316c3.885,0,7.034,3.045,7.034,7.56a8.312,8.312,0,0,1-8.295,8.3c-4.934,0-9.239-3.885-9.239-10.71,0-7.874,4.2-14.909,10.71-19.424Z",
    fill: "#3db6fb"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuoteIcon);
export default __webpack_public_path__ + "static/media/quoteIcon.95d8da282678ef3bb5b689436f7dd46e.svg";
export { ForwardRef as ReactComponent };